<form [formGroup]="form">
  <app-textarea
    formControlName="text"
    [control]="getControl('text')"
    [placeholder]="'Bitte gib deinen Text / Prompt ein...'"
    [size]="'big'">
  </app-textarea>
  <app-select
    formControlName="learncardsRange"
    [control]="getControl('learncardsRange')"
    [label]="'Anzahl der Lernkarten'"
    [options]="['10-20', '20-30']">
  </app-select>
</form>